var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9082 1.22629C19.0939 0.435278 17.1412 0.0189966 15.165 0.00199163C13.1755 -0.0291127 11.2006 0.348844 9.36046 1.11286C7.52029 1.87688 5.85333 3.01098 4.46106 4.44614C1.63422 7.33653 0.0342065 11.2254 0.000587885 15.2873C-0.0330326 19.3493 1.50239 23.2646 4.28099 26.2023L13.4043 35.737C13.588 35.9315 13.8082 36.0871 14.0521 36.1946C14.296 36.3021 14.5587 36.3595 14.8249 36.3632C15.0906 36.3693 15.3546 36.3184 15.5995 36.2139C15.8443 36.1095 16.0645 35.9538 16.2454 35.7572L25.5288 26.3639C28.3584 23.4761 29.962 19.5887 29.9993 15.5268C30.0367 11.4648 28.5048 7.54805 25.7289 4.60775C24.3616 3.16705 22.7225 2.01731 20.9082 1.22629ZM14.8443 20.6384C17.5188 20.6384 19.6869 18.4494 19.6869 15.749C19.6869 13.0487 17.5188 10.8597 14.8443 10.8597C12.1698 10.8597 10.0017 13.0487 10.0017 15.749C10.0017 18.4494 12.1698 20.6384 14.8443 20.6384Z",
    fill: "#4C4F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.6e95524b2acb7a051bf7b001dcd5c34d.svg";
export { ForwardRef as ReactComponent };